// extracted by mini-css-extract-plugin
module.exports = {"container":"SubNavigation_container__3KGRw","horizontal":"SubNavigation_horizontal__1WEC8","vertical":"SubNavigation_vertical__2KVTO","fixed":"SubNavigation_fixed__3uFyI"};